import React from 'react';
import './Testimonials.css';

function Testimonials() {
    return (
        <div className="testimonials-body">
            <div className="container">
                <div className="row container-header">
                    <div className="col-md-6 mx-auto">
                        <div className="testimony">
                            <h1>See how <span>DharManager</span> clients find satisfaction and get it!!</h1>
                        </div>
                    </div>
                    <div className="col-md-12 mx-auto">
                        <div className="testimony">
                            <p>We take a personalized approach to every client engagement. We understand that each organization
                                has its own challenges and goals, which is why we tailor our solutions to meet your specific
                                requirements. Our collaborative and customer-centric approach ensures that your experience with
                                us is nothing short of exceptional.</p>
                        </div>
                    </div>
                </div>

                <div className="col-md-12 testimonial row mx-auto">
                    <div className="col-md-4 mb-5">
                        <div className="testimonial_box">
                            <img src="images/dhart/founderimg.jpg" alt="hr" className="img-fluid" />
                            <div className="test_text">
                                <h1>Founder</h1>
                                <img src="images/dhart/founder.jpg" alt="icon" className="img-fluid" />
                            </div>
                            <h2>Warami-Olorunwanibe</h2>
                            <p>Working with DM has been a game changer for our company. Their expertise and dedication
                                to providing top-notch HR solutions have greatly improved our operations. Highly
                                recommended!</p>
                        </div>
                    </div>
                    <div className="col-md-4 mb-5">
                        <div className="testimonial_box">
                            <img src="images/dhart/founderimg1.jpg" alt="hr" className="img-fluid" />
                            <div className="test_text">
                                <h1>Founder</h1>
                                <img src="images/dhart/founderoluwa.jpg" alt="icon" className="img-fluid" />
                            </div>
                            <h2>Oluwabesibe Forever</h2>
                            <p>I never knew managing HR could be this easy until I started working with DharManager.
                                Their professionalism, efficiency, and personalized approach have made a significant
                                impact on our HR processes. I can’t recommend them enough.</p>
                        </div>
                    </div>
                    <div className="col-md-4 mb-5">
                        <div className="testimonial_box">
                            <img src="images/dhart/cofounderimg.jpg" alt="hr" className="img-fluid" />
                            <div className="test_text">
                                <h1>Co-Founder</h1>
                                <img src="images/dhart/cofounder.jpg" alt="icon" className="img-fluid" />
                            </div>
                            <h2>Georgian Venyl</h2>
                            <p>Since using DM organization, our hr processes have become more efficient and streamlines.
                                Their expertise and personalized approach have made a significant positive impact on our
                                company. Highly recommended!</p>
                        </div>
                    </div>
                    <div className="col-md-4 mx-auto text-center">
                        <button id="more" className="btn btn-primary">More Testimonies</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Testimonials;
